import CheckoutReducer from './checkout_reducer';

export default CheckoutReducer;
